
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Index from './Pages/Index';
import Blog from './Pages/Blog';
import BlogDetails from './Pages/BlogDetails';
import Index1 from './Pages/Index1';

function App() {
  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Index/>} />
      <Route path='/index' element={<Index1/>} />
      <Route path='/Blog' element={<Blog/>} />
      <Route path='/blog-details' element={<BlogDetails/>}/>
    </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
